import React, { useState, useRef, useEffect } from 'react';

export const ActionMenu = ({
  onView,
  onEdit,
  onToggleStatus,
  onDuplicate,
  isActive = true,
  entityName = 'record',
  actions
}) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [open]);

  if (actions && actions.length > 0) {
    return (
      <div className="mst-actions-group" ref={menuRef} style={{ position: 'relative' }}>
        <button
          type="button"
          className="mst-action-btn action-menu-trigger"
          onClick={() => setOpen(prev => !prev)}
          title="Actions"
          aria-label="Actions"
          style={{
            width: 'auto',
            padding: '4px 10px',
            borderRadius: '6px',
            fontSize: '0.8rem',
            fontWeight: 600,
            color: '#334155',
            border: '1px solid #cbd5e1',
            background: '#ffffff',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            cursor: 'pointer'
          }}
        >
          <span>Actions</span>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>

        {open && (
          <div
            className="mst-action-menu action-menu-dropdown"
            style={{
              position: 'absolute',
              right: 0,
              top: 'calc(100% + 4px)',
              background: '#ffffff',
              border: '1px solid #e2e8f0',
              borderRadius: '8px',
              boxShadow: '0 10px 25px -5px rgba(15, 23, 42, 0.15)',
              minWidth: '240px',
              padding: '6px',
              zIndex: 999,
              display: 'flex',
              flexDirection: 'column',
              gap: '2px'
            }}
          >
            {actions.map((act, i) => (
              <button
                key={i}
                type="button"
                className={`mst-action-item action-menu-item ${act.danger ? 'danger' : ''}`}
                style={{
                  textAlign: 'left',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  border: 'none',
                  background: 'none',
                  fontSize: '0.825rem',
                  fontWeight: 600,
                  color: act.danger ? '#dc2626' : '#1e293b',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'background 0.15s'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = act.danger ? '#fef2f2' : '#f1f5f9'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'none'; }}
                onClick={() => {
                  setOpen(false);
                  if (act.onClick) act.onClick();
                }}
              >
                {act.label}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="mst-actions-group" ref={menuRef}>
      {onView && (
        <button
          type="button"
          className="mst-action-btn"
          onClick={onView}
          title={`View ${entityName}`}
          aria-label={`View ${entityName}`}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        </button>
      )}

      {onEdit && (
        <button
          type="button"
          className="mst-action-btn"
          onClick={onEdit}
          title={`Edit ${entityName}`}
          aria-label={`Edit ${entityName}`}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
          </svg>
        </button>
      )}

      {(onToggleStatus || onDuplicate) && (
        <>
          <button
            type="button"
            className="mst-action-btn"
            onClick={() => setOpen(prev => !prev)}
            title="More actions"
            aria-label="More actions"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="1.5" />
              <circle cx="12" cy="5" r="1.5" />
              <circle cx="12" cy="19" r="1.5" />
            </svg>
          </button>

          {open && (
            <div className="mst-action-menu">
              {onDuplicate && (
                <button
                  type="button"
                  className="mst-action-item"
                  onClick={() => {
                    setOpen(false);
                    onDuplicate();
                  }}
                >
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                  </svg>
                  Duplicate
                </button>
              )}

              {onToggleStatus && (
                <button
                  type="button"
                  className={`mst-action-item ${isActive ? 'danger' : ''}`}
                  onClick={() => {
                    setOpen(false);
                    onToggleStatus();
                  }}
                >
                  {isActive ? (
                    <>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                      </svg>
                      Deactivate
                    </>
                  ) : (
                    <>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                      Activate
                    </>
                  )}
                </button>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ActionMenu;
